<div 
 [ngClass]="{'dropdownWidth':params?.contactListShow,
 'dropdown-container':!params?.contactListShow}"
  class="form-floating-renderer py-1 position-relative"
  >
    <select 
      class="form-control dropdown-select" 
      id="custom_select_options" 
      [(ngModel)]="inputValue" 
      [disabled]="params?.data?.isDisable"
      (ngModelChange)="selected($event)">
      <option value=""></option>
      <option *ngFor="let item of list" [value]="item.id"> {{ item.name }} </option>
    </select>
    <span class="dropdown-arrow"></span>
  </div>
  